import _classCallCheck from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/createClass";

var MizzyDevice =
/*#__PURE__*/
function () {
  function MizzyDevice(context) {
    _classCallCheck(this, MizzyDevice);

    this.context = context;
    this.output = this.context.createGain();
    this.effectInput = this.output;
    this.voices = [];
    this.effects = [];
    this._attack = 0;
    this._decay = 0.001;
    this._sustain = this.output.gain.value;
    this._release = 0.001;
  }

  _createClass(MizzyDevice, [{
    key: "NoteOn",
    value: function NoteOn(MidiEvent) {}
  }, {
    key: "NoteOff",
    value: function NoteOff(MidiEvent) {
      if (this.voices[MidiEvent.value] != undefined) {
        this.voices[MidiEvent.value].off(MidiEvent);
      }
    }
  }, {
    key: "onCC",
    value: function onCC(MidiEvent) {}
  }, {
    key: "addEffect",
    value: function addEffect(effect, options) {
      this.effects.push(new effect(this.context));
    }
  }, {
    key: "connectEffects",
    value: function connectEffects() {
      this.effectInput = this.effects[0].input;

      for (var i = this.effects.length - 1; i >= 0; i--) {
        if (i == this.effects.length - 1) {
          this.effects[i].connect(this.output);
        } else {
          this.effects[i].connect(this.effects[i + 1].input);
        }
      }
    }
  }, {
    key: "connect",
    value: function connect(destination) {
      this.output.connect(destination);
    }
  }, {
    key: "disconnect",
    value: function disconnect(destination) {
      this.output.disconnect(destination);
    }
  }, {
    key: "setVoiceValues",
    value: function setVoiceValues() {
      var _this = this;

      this.voices.forEach(function (voice) {
        voice.attack = _this._attack;
        voice.decay = _this._decay;
        voice.sustain = _this._sustain;
        voice.release = _this._release;
      });
    }
  }, {
    key: "attack",
    set: function set(value) {
      this._attack = value;
      this.setVoiceValues();
    },
    get: function get() {
      return this._attack;
    }
  }, {
    key: "decay",
    set: function set(value) {
      this._decay = value;
      this.setVoiceValues();
    },
    get: function get() {
      return this._decay;
    }
  }, {
    key: "sustain",
    set: function set(value) {
      this._sustain = value;
      this.setVoiceValues();
    },
    get: function get() {
      return this._sustain;
    }
  }, {
    key: "release",
    set: function set(value) {
      this._release = value;
      this.setVoiceValues();
    },
    get: function get() {
      return this._release;
    }
  }]);

  return MizzyDevice;
}();

export { MizzyDevice as default };